<template>
  <v-container>
    <v-overlay :value="isSaving">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-row justify="center">
      <v-dialog v-model="successDialog" max-width="450px" persistent>
        <v-card>
          <v-card-title class="font-weight-bold">{{
            successTitle
          }}</v-card-title>
          <v-card-text class="text-xs-h5 mt-2" v-html="successMsg">
            {{ successMsg }}
            <!--     <v-btn v-show="showButton" @click="goToRB()">我的预约</v-btn> -->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="successDialog = false">
              确定
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="font-weight-bold grey--text grey--darken-2"
              >预定信息</span
            >
          </v-card-title>
          <v-divider class="deep-orange"></v-divider>
          <v-card-text style="height: 100%">
            <v-container
              ><!--
            <v-row>
              <v-col cols="12" sm="12" md="12">
              <v-alert
                border="left"
                colored-border
                type="error"
                elevation="2"
              >
                 请注意，目前场地采用随机方式分配，具体分配场地号请查看“我的预定”中的预定详情。
              </v-alert>
                </v-col>
              </v-row>-->
              <v-row>
                <v-col cols="6" sm="3" md="3" style="padding: 0px" class="mr-4">
                  <v-text-field
                    :label="name"
                    v-model="userInfo.name"
                    :disabled="formStyle.Type != 'GROUP'"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="4" md="4" style="padding: 0px" class="mr-4">
                  <v-text-field
                    label="学工号/身份证号"
                    v-model="userInfo.id"
                    :disabled="formStyle.Type != 'GROUP'"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4" style="padding: 0px">
                  <v-text-field
                    label="电话"
                    v-model="userInfo.tel"
                  ></v-text-field>
                </v-col>

                <v-col
                  v-show="formStyle.Type == 'GROUP'"
                  cols="6"
                  sm="3"
                  md="3"
                  style="padding: 0px"
                  class="mr-4"
                >
                  <v-text-field
                    label="参观人数"
                    v-model.number="capacity"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-show="formStyle.Type == 'GROUP'"
                  cols="12"
                  sm="4"
                  md="4"
                  style="padding: 0px"
                  class="mr-4"
                >
                  <v-text-field
                    v-model="extraInfo.groupName"
                    label="团体名称"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-show="formStyle.Type == 'GROUP'"
                  cols="12"
                  sm="4"
                  md="4"
                  style="padding: 0px"
                >
                  <v-select
                    :items="items"
                    v-model="extraInfo.type"
                    label="团体类型"
                  ></v-select>
                </v-col>
                <!--  <v-col
                  v-show="formStyle.Type == 'GROUP'"
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-textarea
                    outlined
                    persistent-hint
                    name="input-7-4"
                    label="具体信息"
                    :hint="hint"
                    v-model="moreInfo"
                    :rules="[rules.required]"
                  ></v-textarea>
                </v-col>-->
              </v-row>
              <!--    <v-row v-if="formStyle.Type != 'GROUP'">
                <v-col cols="12" lg="3" md="3" sm="3">
                  <v-checkbox
                    v-model="extraInfo.isAlumni"
                    label="校友"
                    style="margin: 0px"
                  ></v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  lg="3"
                  md="3"
                  sm="3"
                  style="padding: 0px"
                  v-show="extraInfo.isAlumni"
                >
                  <v-text-field
                    v-model="extraInfo.graduateYear"
                    label="毕业年份"
                    style="margin: 0px"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  lg="4"
                  md="4"
                  sm="4"
                  style="padding: 0px"
                  v-show="!extraInfo.isAlumni"
                >
                  <v-text-field
                    v-model="extraInfo.zone"
                    label="校区"
                    style="margin: 0px"
                    class="mr-4"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  lg="4"
                  md="4"
                  sm="4"
                  style="padding: 0px"
                  v-show="!extraInfo.isAlumni"
                >
                  <v-text-field
                    v-model="extraInfo.dept"
                    label="单位"
                    style="margin: 0px"
                  ></v-text-field>
                </v-col>
              </v-row>-->
              <v-row>
                <v-col cols="12" lg="3" md="3" sm="3" style="padding: 0px">
                  <v-select :items="roles" v-model="extraInfo.role" label="身份"></v-select>
                </v-col>
              </v-row>
              <v-row v-show="formStyle.Type == 'GROUP'">
                <v-col cols="9" lg="9" md="9" sm="9">
                  <v-file-input
                    label="上传申请表"
                    outlined
                    dense
                    v-model="uploadFile"
                  ></v-file-input>
                </v-col>
                <v-col cols="1" lg="1" md="1" sm="1">
                  <v-btn
                    color="primary"
                    outlined
                    @click="doUpload"
                    :disabled="!this.uploadFile || files.length == 1"
                    >上传</v-btn
                  >
                </v-col>
                <v-col cols="12" lg="12" md="12" sm="12">
                  <v-card v-show="files.length > 0">
                    <v-list flat>
                      <v-subheader>已上传文件</v-subheader>
                      <v-list-item v-for="file in files" :key="file.identity">
                        <v-list-item-avatar>
                          <v-icon>mdi-file</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content style="text-align: start">
                          <v-list-item-title
                            v-html="getHyperLink(file)"
                          ></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-icon>
                          <v-icon @click="deleteFile(file)">
                            mdi-delete
                          </v-icon>
                        </v-list-item-icon>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>

              <v-row v-if="formStyle.Type != 'GROUP'">
                <v-btn color="primary" outlined small @click="addParticipants"
                  >添加同行人</v-btn
                >
              </v-row>

              <v-row
                style="padding: 0px; border: 1px solid #9e9e9e"
                class="ma-4 pa-2"
                v-for="item in participants"
                :key="item.no"
              >
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  style="padding: 0px"
                  class="mr-2"
                >
                  <v-text-field label="姓名" v-model="item.name"></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="5"
                  md="5"
                  style="padding: 0px"
                  class="mr-4"
                >
                  <v-text-field label="证件号" v-model="item.id"></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" style="padding: 0px">
                  <v-text-field label="电话" v-model="item.tel"></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="3" sm="3">
                  <v-checkbox
                    v-model="item.isAlumni"
                    label="校友"
                    style="margin: 0px"
                  ></v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  lg="3"
                  md="3"
                  sm="3"
                  style="padding: 0px"
                  v-show="item.isAlumni"
                >
                  <v-text-field
                    v-model="item.graduateYear"
                    label="毕业年份"
                    style="margin: 0px"
                    class="mr-4"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="1"
                  md="1"
                  style="padding: 0px"
                  class="mt-4 mr-4"
                  @click="remove(item)"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions v-show="!isSaving">
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="
                capacity = 1;
                uploadFile = null;
                files = [];
                dialog = false;
                isError = false;
              "
              >关闭</v-btn
            >
            <v-btn color="green darken-1" text @click="recaptcha">预约</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { EventBus } from "@/plugins/event-bus";
import { mapGetters } from "vuex";
import { eventService } from "@/api/event.service";
import moment from "moment";

export default {
  name: "bookingForm",
  props: {
    formStyle: {
      type: Object,
    },
  },
  data: () => ({
    height: 200,
    dialog: false,
    successDialog: false,
    isSaving: false,
    isAlumni: false,
    participants: [],
    roles: ['教职工','学生'],
    role: '',
    extraInfo: { isAlumni: false, graduateYear: "", role: "" ,type: "", dept: "" },
    userInfo: { name: "", id: "", tel: "" },
    items: ["学校", "机关部委", "企事业单位", "其它"],
    selectedItem: "",
    moreInfo: "",
    hint: "",
    name: "领队姓名",
    capacity: 20,
    rules: {
      required: (value) => !!value || "必填",
      //number: (value) => value <= 20 || "最多20人",
    },
    uploadFile: null,
    files: [],
    bookingSlotInfo: null,
    successTitle: "",
    successMsg: "",
    showButton: false,
    isAgree: false,
    isError: false,
    msg: "我同意遵循游泳馆使用规则",
  }),
  async mounted() {
    this.initialize();

    EventBus.$on("openModal", async (slot) => {
      this.initialize();
      this.dialog = true;
      this.bookingSlotInfo = slot;
      this.capacity = 1;
    });
  },
  watch: {
    selectedItem(val) {
      if (val == "校友") this.hint = "请输入校友的专业，年级和班级";
      if (val == "教职工") this.hint = "请输入教职工所属单位";
      if (val == "学生") this.hint = "请输入学生所属学院，年级和班级";
      if (val == "访客") this.hint = "请输入访客的姓名，单位和职务";
    },
  },
  computed: {
    ...mapGetters(["userProfile"]),
  },
  methods: {
    remove(item) {
      let idx = this.participants.findIndex((x) => x.no == item.no);
      if (idx != -1) this.participants.splice(idx, 1);
    },
    addParticipants() {
      if (this.participants.length >= 5) {
        alert("您最多可以添加五名同行人");
        return;
      }
      let _new = {
        no: this.participants.length + 1,
        name: "",
        id: "",
        tel: "",
      };
      this.participants.push(_new);
    },
    async save(token) {
      if (this.validateForm()) {
        this.dialog = false;
        this.isSaving = true;

        let templateId = this.$route.params.id;
        let eventSlot = this.bookingSlotInfo.EventSlot;
        let startTime =
          this.bookingSlotInfo.Date +
          "T" +
          moment(eventSlot.StartTime).format("HH:mm:sszzz");
        let endTime =
          this.bookingSlotInfo.Date +
          "T" +
          moment(eventSlot.EndTime).format("HH:mm:sszzz");

        this.extraInfo.userInfo = this.userInfo;

        this.extraInfo.participants = this.participants;
        console.log("File");
        console.log(this.files);

        if (this.files.length > 0) this.extraInfo.file = this.files[0].url;

        let descr = JSON.stringify(this.extraInfo);

        this.capacity =
          this.formStyle.Type != "GROUP"
            ? this.participants.length + 1
            : this.capacity;

        let payload = {
          TemplateId: templateId,
          Description: descr,
          StartDateTime: startTime,
          EndDateTime: endTime,
          size: this.capacity,
          GoogleToken: token,
        };

        // try{
        let result = await eventService.postBatchBook(payload);

        if (result.ExceptionMessage) {
          //if it is wrong
          this.successTitle = "预约失败";
          this.successMsg =
            "您的请求于当前时间不能被满足，请换个时间预约。 " +
            result.ExceptionMessage;
        } else if (result.Reference) {
          this.successTitle = "预定成功";

          if (this.formStyle.ApprovalRequired)
            this.successMsg =
              "您的预定已经提交，等待审批。预定编号:" +
              result.Reference +
              "。您可前往<a href='" +
              process.env.VUE_APP_RBURL +
              "' target ='_blank'>我的预定</a>查看相关信息。";
          // + result ;
          else
            this.successMsg =
              "您已经预定成功，预定编号:" +
              result.Reference +
              "。您可前往<a href='" +
              process.env.VUE_APP_RBURL +
              "' target ='_blank'>我的预定</a>查看相关信息。";
        } else {
          this.successTitle = "预约失败";
          this.successMsg = "您的请求于当前时间不能被满足，请换个时间预约。";
        }
        this.showButton = true;

        //}
        /*catch(e)
            {
              console.log("ERR: "+ e.message);
              this.successTitle = "出错啦！";
              this.successMsg = "您的请求于当前时间不能被满足，请换个时间预约。";
            }*/

        this.capacity = 1;
        this.extraInfo = {
          isAlumni: false,
          graduateYear: "",
          type: "",
          dept: "",
          type: "",
          groupName: "",
        };
        this.uploadFile = null;
        this.files = [];
        this.showButton = false;
        EventBus.$emit("saved", "success");

        //await this.$store.dispatch('getEventSlot', { id: templateId, from: moment().format('YYYY-MM-DD'), to: moment().add('days', 7).format('YYYY-MM-DD')}) ;

        this.isSaving = false;
        this.successDialog = true;
      } else {
        if (this.formStyle.Name != "游泳馆预约") this.successDialog = true;
      }
    },
    validateForm() {
      let flag = true;
      if (!this.isAgree && this.formStyle.Name == "游泳馆预约") {
        this.isError = true;
        this.successTitle = "游泳馆使用提示";
        this.successMsg = "请阅读游泳馆使用规定后并勾选我同意选框才能继续预约";
        return false;
      }
      //if (!this.formStyle.ApprovalRequired) return true;
      //if (!this.$route.params.id || !this.selectedItem || !this.moreInfo || !this.capacity || this.capacity<2 || (this.capacity>this.formStyle.DefaultSize && !this.bookingSlotInfo.isAdmin))
      if (this.formStyle.Type == "GROUP") {
        if (
          !this.userInfo.name ||
          !this.userInfo.id ||
          !this.userInfo.tel ||
          !this.extraInfo.type ||
          !this.extraInfo.groupName ||
          this.files.length == 0
        ) {
          this.successTitle = "出错啦！";
          this.successMsg = "请完善表格再提交";
          flag = false;
          return false;
        }
        return true;
      } else {
        if (this.participants.length > 0) {
          this.participants.forEach((p) => {
            if (!p.name || !p.id || !p.tel) {
              this.successTitle = "出错啦！";
              this.successMsg = "请完善表格再提交";
              flag = false;
            }
          });
        }

        if (flag == false) return false;

        if (!this.userInfo.tel || !this.extraInfo.role) {
          this.successTitle = "出错啦！";
          this.successMsg = "请完善表格再提交";
          return false;
        } else return true;
      }
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded();

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha("login");

      // Do stuff with the received token.
      this.save(token);
    },
    async initialize() {
      if (!this.userProfile) await this.$store.dispatch("getUserProfile");
      this.userInfo.name = this.userProfile.Name;
      this.userInfo.id = this.userProfile.Email.split("@")[0];
      if (this.formStyle.Type == "GROUP") this.name = "领队姓名";
      else this.name = "姓名";
    },
    goToRB() {
      var url = process.env.VUE_APP_RBURL;
      window.location.href = url;
    },
    async doUpload() {
      let formData = new FormData();
      formData.append("files[]", this.uploadFile);
      let payload = { identity: this.$route.params.id, file: formData };
      this.isLoading = true;
      let result = await eventService.uploadFile(payload);
      this.isLoading = false;
      this.files.push({
        name: result.split("/")[3],
        size: this.uploadFile.size,
        identity: result,
        url:
          process.env.VUE_APP_HOST +
          "api/Time/Attachment?attachmentReference=" +
          result,
      });
    },
    deleteFile(item) {
      let idx = this.files.findIndex((x) => x.result == item.result);
      this.files.splice(idx, 1);
    },
    getHyperLink(file) {
      this.moreInfo = file.url;
      return (
        "<a href='" +
        file.url +
        "'>" +
        file.name +
        "</a>  " +
        file.size +
        " Bytes"
      );
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/BookingForm/BookingForm.vue